<template>
  <RouterView name="header" v-slot="{ Component }">
    <aside
      class="print:hidden"
      :class="{
        'container print:mx-0 print:min-w-full': !route.meta.width,
      }"
    >
      <component :is="Component" />
    </aside>
  </RouterView>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
</script>
